<template>
  	<FlexPinBatchSaleReport />
</template>

<script>

// @ is an alias to /src
import FlexPinBatchSaleReport from "@/components/reports/Flex/PinBatchSaleReport.vue";

export default {
  name: "FlexPinBatchSaleReportView",
  components: {
    FlexPinBatchSaleReport,
  },
};
</script>
